import type { ProgressProps } from '../progress'

export enum TIMING {
  'random' = 'random',
  'linear' = 'linear',
  'ease-in-out' = 'ease-in-out',
  'custom' = 'custom',
}

export type SetTimeoutVariable = ReturnType<typeof setTimeout> | number

export type PickProgressProps =
  | 'percentage'
  | 'color'
  | 'strokeWidth'
  | 'showText'
  | 'status'
  | 'striped'
  | 'stripedFlow'
  | 'textInside'
  | 'format'

export interface ProgressBarCfg
  extends Partial<Pick<ProgressProps, PickProgressProps>> {
  zIndex?: number
  timing?: string
  duration?: number // 0 - 手动设置 percentage， 不为 0 - 内置模拟加载计算
  delay?: number
  shadow?: boolean
  visible?: boolean
  steps?: string[]
  maxPercentage?: number
  showCompleteStatus?: boolean
  callback?: (callback: () => void) => any
  /**
   * @param t 时间进度 = 当前时间戳 - 起始时间戳
   * @param b 初始值 = config.percentage
   * @param c 变化值 = 100 - b
   * @param d 持续时间 = config.duration
   * @return 当前时间的变化值 => 加上初始值就是显示值
   */
  customTiming?: (t: number, b: number, c: number, d: number) => number
}

export interface ProgressBarReturn {
  vm: any
  instance: any
  update: (percentage: number) => void
  done: () => void
  destroy: () => void
}
